module.exports = __webpack_public_path__ + "img/thumb-p4.701b8fae.png";